/**
 * 步骤实体
 * zxw
 * 创建时间 2026-02-01
 */

import CNF from '../../incs/Config';
import { rootReactDom, Html2pdf } from '../../incs/FunHelper';
import { useState, useRef, useEffect, useCallback } from 'react';
import {
    Flex,
    theme,
    Button,
    Space,
    Avatar,
    Typography,
    Collapse,
    Divider,
    message,
    Select,
    Tag,
    Tooltip,
} from 'antd';
import {
    SyncOutlined,
    CopyOutlined,
    ExpandAltOutlined,
    CheckCircleFilled,
    ExportOutlined,
} from '@ant-design/icons';

import { XMarkdown } from '@ant-design/x-markdown';
import Latex from '@ant-design/x-markdown/plugins/Latex';   // 公式
import { CodeHighlighter } from '@ant-design/x';
import '@ant-design/x-markdown/themes/light.css';

// 思维链
import XinYuanThink from './XinYuanThink';

// 引入组件
import IOPutFullScreen from './IOPutFullScreen';
import {
    ImageSkeleton,
    IncompleteLink,
    TableSkeleton,
    HtmlSkeleton,
    IncompleteEmphasis,
    IncompleteInlineCode,
    WelcomeCard,
    Code,
} from '../../components/Incomplete';

const { Text } = Typography;

const StepEntity = (props) => {
    const {
        token: {
            colorStepBgActive,
            colorTextBase,
            colorBgSolid,
            colorStepBg,
            fontSizeSM,
        },
    } = theme.useToken();
    const [messageApi, contextHolder] = message.useMessage();

    // 输入输出展开
    const [inputActiveKey, setInputActiveKey] = useState([]);
    const [outputActiveKey, setOutputActiveKey] = useState([]);

    // 输入输出格式
    const [inputFormat, setInputFormat] = useState('Json');
    const [outputFormat, setOutputFormat] = useState('Text');

    // 最终输出展开
    const [endOutPutActiveKey, setEndOutPutActiveKey] = useState(['1']);
    // 最终输出格式
    const [endOutPutFormat, setEndOutPutFormat] = useState('Markdown');

    /***************打印动画配置***************/
    const className = props.isDarkMode ? 'x-markdown-dark' : 'x-markdown-light';
    const [hasNextChunk, setHasNextChunk] = useState(true);
    const [index, setIndex] = useState(0);
    const timer = useRef(null);

    const scrollToBottom = useCallback(
        el => {
            if (el && index > 0) {
                const { scrollHeight, clientHeight } = el;
                if (scrollHeight > clientHeight) {
                    el.scrollTo({ top: scrollHeight, behavior: 'smooth' });
                }
            }
        },
        [index],
    );

    useEffect(() => {
        if (props.node.key === 'End') {
            if (index >= props.node.output.result.length) {
                setHasNextChunk(false);
                props.setRunStatus(false); // 输出结束
                return;
            }
            timer.current = setTimeout(() => {
                setIndex(Math.min(index + 2, props.node.output.result.length));
            }, 20);
            return () => {
                if (timer.current) {
                    clearTimeout(timer.current);
                    timer.current = null;
                }
            };
        }

    }, [index]);

    useEffect(() => {
        if (props.node.key === 'End') {
            if (index > 0) {
                scrollToBottom(props.contentRef.current);
            }
        }
    }, [index, scrollToBottom]);
    /***************打印动画配置***************/

    /**
     * 输入输出全屏展示
     * @param {*} title 
     * @param {*} format 
     * @param {*} content 
     */
    const openIOPutFullScreen = (title, format, content) => {
        rootReactDom && rootReactDom.render(
            <IOPutFullScreen
                open={true}
                isDarkMode={props.isDarkMode}
                title={title}
                format={format}
                content={content}
            />
        );
    }

    return <>
        {contextHolder}
        <Collapse
            size='small'
            ghost
            expandIconPlacement='end'
            style={{ border: 0 }}
            styles={{
                header: {
                    background: colorStepBg,
                    padding: 5,
                },
                body: {
                    padding: 5,
                }
            }}
            items={[{
                key: '1',
                label: <Space style={{ display: 'flex', alignItems: 'center' }}>
                    {<Avatar shape='square' size={22} style={{ background: props.node.theme, color: '#fff' }} icon={props.stepIsRunning ? <SyncOutlined spin /> : CNF.nodeConfig[props.node.key.toLowerCase()].icon} />}
                    <Text style={{ color: colorTextBase, fontSize: fontSizeSM, }}>{props.node.title ? props.node.title : props.node.nodeType}</Text>
                    {
                        !props.stepIsRunning ? <Tag style={{ height: '16px', lineHeight: '14px', padding: '0 4px', alignItems: 'center', fontSize: '9px' }} key='success' color='success' icon={<CheckCircleFilled />} variant='outlined'>
                            <span>{props.node.runTime}ms</span>
                        </Tag> : ''
                    }
                </Space>,
                children: <Space orientation='vertical' style={{ display: 'flex', }}>
                    <div>
                        {
                            // 输入
                            props.node.input ? <Collapse
                                collapsible='icon'
                                size='small'
                                ghost
                                style={{ border: `1px solid ${colorBgSolid}`, background: '#fff', }}
                                styles={{
                                    header: {
                                        background: colorStepBgActive,
                                        padding: 5,
                                        borderRadius: inputActiveKey.length > 0 ? '8px 8px 0 0' : '8px',
                                    },
                                    body: {
                                        background: '#fff',
                                        borderRadius: '0 0 8px 8px',
                                    },
                                }}
                                onChange={(key) => {
                                    setInputActiveKey(key);
                                }}
                                items={[{
                                    key: '1',
                                    label: <Flex style={{ color: colorTextBase, fontSize: fontSizeSM, display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '60%' }}>输入</div>
                                        <div style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}><Space size={0}>
                                            <Select
                                                size='small'
                                                variant='borderless'
                                                value={inputFormat}
                                                popupMatchSelectWidth={false}
                                                onChange={(value) => setInputFormat(value)}
                                                styles={{ root: { color: colorTextBase, fontSize: fontSizeSM, } }}
                                                options={CNF.displayFormats.map((item) => ({ value: item, label: item }))}
                                            />
                                            <Divider vertical />
                                            <Tooltip title='复制'>
                                                <Button
                                                    color='default'
                                                    variant='text'
                                                    size='small'
                                                    style={{ color: colorTextBase, fontSize: fontSizeSM, }}
                                                    onClick={() => {
                                                        // 获取不同格式的内容
                                                        let content = '';
                                                        if (inputFormat === 'Json') {
                                                            content = JSON.stringify(props.node.input, null, 2);
                                                        } else if (inputFormat === 'Text') {
                                                            content = JSON.stringify(props.node.input);
                                                        } else {
                                                            content = props.node.input;
                                                        }
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(content).then(() => {
                                                                // 复制成功
                                                                messageApi.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                messageApi.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = content;
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            messageApi.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                ><CopyOutlined />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title='全屏'>
                                                <Button
                                                    color='default'
                                                    variant='text'
                                                    size='small'
                                                    style={{ color: colorTextBase, fontSize: fontSizeSM, }}
                                                    onClick={() => {
                                                        openIOPutFullScreen('输入', inputFormat, props.node.input)
                                                    }}
                                                ><ExpandAltOutlined />
                                                </Button>
                                            </Tooltip>
                                        </Space></div>
                                    </Flex>,
                                    children: <>
                                        {
                                            inputFormat === 'Json' ? <CodeHighlighter
                                                lang='json'
                                                styles={{
                                                    header: {
                                                        display: 'none',
                                                    },
                                                    code: {
                                                        border: 0,
                                                        background: '#fff'
                                                    }
                                                }}>{JSON.stringify(props.node.input, null, 2)}</CodeHighlighter>
                                                :
                                                inputFormat === 'Text' ? <Text style={{ color: CNF.baseTextColor, fontSize: fontSizeSM, }}>{JSON.stringify(props.node.input)}</Text>
                                                    : <XMarkdown
                                                        content={props.node.input}
                                                        streaming={{ enableAnimation, hasNextChunk, animationConfig: { fadeDuration: 200 } }}
                                                        className={'x-markdown-light'}
                                                        style={{
                                                            wordWrap: 'break-word',
                                                            overflowX: 'hidden',
                                                            overflowWrap: 'break-word',
                                                            padding: 8,
                                                        }}
                                                        components={{
                                                            code: Code,
                                                            'think': XinYuanThink,
                                                        }}
                                                        config={{
                                                            extensions: Latex(),
                                                        }}
                                                        paragraphTag='div'
                                                    />
                                        }
                                    </>
                                }]}
                            /> : ''
                        }
                    </div>
                    <div>
                        {
                            // 输出
                            props.node.output ? <Collapse
                                collapsible='icon'
                                size='small'
                                ghost
                                style={{ border: `1px solid ${colorBgSolid}`, background: '#fff', }}
                                styles={{
                                    header: {
                                        background: colorStepBgActive,
                                        padding: 5,
                                        borderRadius: outputActiveKey.length > 0 ? '8px 8px 0 0' : '8px',
                                    },
                                    body: {
                                        background: '#fff',
                                        borderRadius: '0 0 8px 8px',
                                    },
                                }}
                                onChange={(key) => {
                                    setOutputActiveKey(key);
                                }}
                                items={[{
                                    key: '2',
                                    label: <Flex style={{ color: colorTextBase, fontSize: fontSizeSM, display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '60%' }}>输出</div>
                                        <div style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}><Space size={0}>
                                            <Select
                                                size='small'
                                                variant='borderless'
                                                value={outputFormat}
                                                popupMatchSelectWidth={false}
                                                onChange={(value) => setOutputFormat(value)}
                                                styles={{ root: { color: colorTextBase, fontSize: fontSizeSM, } }}
                                                options={CNF.displayFormats.map((item) => ({ value: item, label: item }))}
                                            />
                                            <Divider vertical />
                                            <Tooltip title='复制'>
                                                <Button
                                                    color='default'
                                                    variant='text'
                                                    size='small'
                                                    style={{ color: colorTextBase, fontSize: fontSizeSM, }}
                                                    onClick={() => {
                                                        const outputContent = props.node.key === 'End' ? props.node.output.result : props.node.output;
                                                        // 获取不同格式的内容
                                                        let content = '';
                                                        if (inputFormat === 'Json') {
                                                            content = JSON.stringify(outputContent, null, 2);
                                                        } else if (inputFormat === 'Text') {
                                                            content = JSON.stringify(outputContent);
                                                        } else {
                                                            content = outputContent;
                                                        }
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(content).then(() => {
                                                                // 复制成功
                                                                messageApi.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                messageApi.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = content;
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            messageApi.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                ><CopyOutlined />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title='全屏'>
                                                <Button
                                                    color='default'
                                                    variant='text'
                                                    size='small'
                                                    style={{ color: colorTextBase, fontSize: fontSizeSM, }}
                                                    onClick={() => {
                                                        openIOPutFullScreen('输出', outputFormat, props.node.output.result)
                                                    }}
                                                ><ExpandAltOutlined />
                                                </Button>
                                            </Tooltip>
                                        </Space></div>
                                    </Flex>,
                                    children: <>
                                        {
                                            outputFormat === 'Json' ? <CodeHighlighter
                                                lang='json'
                                                styles={{
                                                    header: {
                                                        display: 'none',
                                                    },
                                                    code: {
                                                        border: 0,
                                                        background: '#fff'
                                                    }
                                                }}>{props.node.key === 'End' ? JSON.stringify(props.node.output.result, null, 2) : JSON.stringify(props.node.output, null, 2)}</CodeHighlighter>
                                                :
                                                outputFormat === 'Text' ? <Text style={{ color: CNF.baseTextColor, fontSize: fontSizeSM, }}>{props.node.key === 'End' ? JSON.stringify(props.node.output.result) : JSON.stringify(props.node.output)}</Text>
                                                    : <XMarkdown
                                                        content={props.node.key === 'End' ? props.node.output.result : props.node.output}
                                                        streaming={{ enableAnimation, hasNextChunk, animationConfig: { fadeDuration: 200 } }}
                                                        className={'x-markdown-light'}
                                                        style={{
                                                            wordWrap: 'break-word',
                                                            overflowX: 'hidden',
                                                            overflowWrap: 'break-word',
                                                            padding: 8,
                                                        }}
                                                        components={{
                                                            code: Code,
                                                            'think': XinYuanThink,
                                                        }}
                                                        config={{
                                                            extensions: Latex(),
                                                        }}
                                                        paragraphTag='div'
                                                    />
                                        }
                                    </>
                                }]}
                            /> : ''
                        }
                    </div>
                </Space>
            }]}
        />
        {
            // 结束节点，工作流输出。
            props.node && props.node.key === 'End' ? <div style={{ background: props.isDarkMode ? '#000' : '#fff', paddingTop: 10, }}>
                <Collapse
                    size='small'
                    collapsible='icon'
                    ghost
                    expandIconPlacement='end'
                    style={{ border: `1px solid ${colorBgSolid}`, }}
                    styles={{
                        header: {
                            background: colorStepBg,
                            padding: 5,
                            borderRadius: endOutPutActiveKey.length ? '8px 8px 0 0' : '8px',
                        },
                        body: {
                            padding: 5,
                        }
                    }}
                    activeKey={endOutPutActiveKey}
                    onChange={(key) => {
                        setEndOutPutActiveKey(key);
                    }}
                    items={[{
                        key: '1',
                        label: <Space style={{ display: 'flex', alignItems: 'center' }}>
                            <Text style={{ color: colorTextBase, fontSize: fontSizeSM, }}>工作流最终输出：{props.node.title ? props.node.title : props.node.nodeType}节点</Text>
                            <Select
                                size='small'
                                variant='borderless'
                                value={endOutPutFormat}
                                popupMatchSelectWidth={false}
                                onChange={(value) => setEndOutPutFormat(value)}
                                styles={{ root: { color: colorTextBase, fontSize: fontSizeSM, } }}
                                options={CNF.displayFormats.map((item) => ({ value: item, label: item }))}
                            />
                            <Divider vertical style={{ padding: 0, margin: 0 }} />
                            <Tooltip title='复制'>
                                <Button
                                    color='default'
                                    variant='text'
                                    size='small'
                                    style={{ color: colorTextBase, fontSize: fontSizeSM, margin: 0 }}
                                    onClick={() => {// 获取不同格式的内容
                                        let content = '';
                                        if (inputFormat === 'Json') {
                                            content = JSON.stringify(props.node.output.result, null, 2);
                                        } else if (inputFormat === 'Text') {
                                            content = JSON.stringify(props.node.output.result);
                                        } else {
                                            content = props.node.output.result;
                                        }
                                        if (content.startsWith('"') && content.endsWith('"')) {
                                            // 去除前后的双引号
                                            content = content.slice(1, -1);
                                        }
                                        if (navigator.clipboard && window.isSecureContext) {
                                            navigator.clipboard.writeText(content).then(() => {
                                                // 复制成功
                                                messageApi.success('复制成功！', CNF.messageDuration);
                                            }).catch((error) => {
                                                // 复制失败
                                                messageApi.error(error, CNF.messageDuration);
                                            })
                                        } else {
                                            const input = document.createElement('textarea');
                                            input.value = content;
                                            document.body.appendChild(input);
                                            input.select();
                                            document.execCommand('copy');
                                            document.body.removeChild(input);
                                            messageApi.success('复制成功！', CNF.messageDuration);
                                        }
                                    }}
                                ><CopyOutlined />
                                </Button>
                            </Tooltip>
                            <Tooltip title='全屏'>
                                <Button
                                    color='default'
                                    variant='text'
                                    size='small'
                                    style={{ color: colorTextBase, fontSize: fontSizeSM, margin: 0 }}
                                    onClick={() => {
                                        openIOPutFullScreen('输出', endOutPutFormat, props.node.output.result)
                                    }}
                                ><ExpandAltOutlined />
                                </Button>
                            </Tooltip>
                            <Divider vertical style={{ padding: 0, margin: 0 }} />
                            <Tooltip title='导出'>
                                <Button
                                    color='default'
                                    variant='text'
                                    size='small'
                                    style={{ color: colorTextBase, fontSize: fontSizeSM, margin: 0 }}
                                    onClick={() => {
                                        // 导出
                                        Html2pdf('print-view-id', props.appInfo?.app_name);
                                    }}
                                ><ExportOutlined />
                                </Button>
                            </Tooltip>
                        </Space>,
                        children: <>
                            {
                                // Json输出
                                endOutPutFormat === 'Json' ?
                                    <div id='print-view-id'>
                                        <CodeHighlighter
                                            lang='json'
                                            styles={{
                                                header: {
                                                    display: 'none',
                                                },
                                                code: {
                                                    border: 0,
                                                    background: '#fff'
                                                }
                                            }}>{JSON.stringify(props.node.output.result, null, 2)}
                                        </CodeHighlighter>
                                    </div>
                                    :
                                    // Text输出
                                    endOutPutFormat === 'Text' ?
                                        <div id='print-view-id'><Text style={{ color: CNF.baseTextColor, fontSize: fontSizeSM, }}>{JSON.stringify(props.node.output.result)}</Text></div>
                                        :
                                        <div id='print-view-id'>
                                            <XMarkdown
                                                content={props.node.output.result.slice(0, index)}
                                                className={className}
                                                paragraphTag='div'
                                                openLinksInNewTab
                                                dompurifyConfig={{ ADD_ATTR: ['icon', 'description'] }}
                                                style={{
                                                    wordWrap: 'break-word',
                                                    overflowX: 'hidden',
                                                    overflowWrap: 'break-word',
                                                    padding: 8,
                                                }}
                                                components={{
                                                    code: Code,
                                                    'think': XinYuanThink,
                                                    'incomplete-image': ImageSkeleton,
                                                    'incomplete-link': IncompleteLink,
                                                    'incomplete-table': TableSkeleton,
                                                    'incomplete-html': HtmlSkeleton,
                                                    'incomplete-emphasis': IncompleteEmphasis,
                                                    'incomplete-inline-code': IncompleteInlineCode,
                                                    welcome: WelcomeCard,
                                                }}
                                                config={{
                                                    extensions: Latex(),
                                                }}
                                                streaming={{ hasNextChunk }}
                                            />
                                        </div>
                            }
                        </>
                    }]}
                /></div> : ''
        }

    </>
}

export default StepEntity;